import { render, staticRenderFns } from "./DeliveryActivityList.vue?vue&type=template&id=56bc559c"
import script from "./DeliveryActivityList.vue?vue&type=script&lang=js"
export * from "./DeliveryActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports